__webpack_require__.p = "/onboarding-cdk-styles/referrals-hub/";